// Generic stand-in for Electron/Node-only modules in the web build.
// Every property reads as undefined so feature-detection in the renderer
// (`if (mod.someFn !== undefined)`) fuses the dependent code path off.
module.exports = {};
